import styled from "styled-components";

const c = {
  black: "#1e1e1e",
  white: "#ffffff",

  gold: "#c9a227",
  goldSoft: "rgba(201,162,39,0.25)",

  pink: "#fc9ac4",
  pinkStrong: "#ff77b4",
  pinkSoft: "rgba(252,154,196,0.14)",

  textOnBlack: "rgba(255,255,255,0.92)",
};

export const TopBarWrapper = styled.div`
  position: sticky;
  top: 0;
  z-index: 99999;

  width: 100%;
  background: ${c.black};

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 16px 22px;

  border-top: 1px solid ${c.gold};
  border-bottom: 1px solid rgba(201, 162, 39, 0.35);

  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.06),
    0 10px 30px rgba(0, 0, 0, 0.35);
`;

export const ButtonTab = styled.span`
  font-family: "Cormorant Garamond", serif;
  font-weight: 600;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-size: 16px;

  color: ${c.textOnBlack};
  opacity: ${(props) => (props.active ? 1 : 0.6)};

  padding: 6px 2px 12px;
  position: relative;

  transition:
    opacity 0.2s ease,
    transform 0.2s ease;

  cursor: pointer;

  &:hover {
    opacity: 1;
    transform: translateY(-1px);
  }

  &::after {
    content: "";
    position: absolute;
    left: 15%;
    right: 15%;
    bottom: 4px;
    height: 1.5px;

    background: ${c.gold};
    opacity: ${(props) => (props.active ? 0.9 : 0)};
    transform: scaleX(${(props) => (props.active ? 1 : 0.7)});
    transition: all 0.25s ease;
  }

  &:hover::after {
    opacity: 0.8;
    transform: scaleX(1);
  }
`;

export const CloseButton = styled.div`
  color: ${c.pinkStrong};
  font-size: 26px;
  font-weight: 600;

  width: 40px;
  height: 40px;
  border-radius: 999px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: 1px solid rgba(201, 162, 39, 0.35);
  background: rgba(255, 255, 255, 0.05);

  transition: all 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    border-color: rgba(252, 154, 196, 0.7);
    background: rgba(252, 154, 196, 0.08);
  }
`;
